import React from "react";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import SecureConnected from "../components/SecureConnected";
import { SiteFooter, SiteHeader } from "../components/SiteChrome";
import useScrollReveal from "../hooks/useScrollReveal";
import partnerHero from "../assets/figma/partner-with-trilloan.png";
import "./Partners.css";

const partnerBenefits = [
  {
    title: "Employee and Non-Employee Borrowers",
    copy: "Mas maraming borrowers, mas maraming opportunity.",
    bullets: ["Mas malawak na market", "Flexible borrower options"],
  },
  {
    title: "Dedicated Lending App",
    copy: "Sariling lending platform na naka-brand para sa iyong negosyo.",
    bullets: ["Kontrolado ang audience", "Mas mataas na loan visibility"],
  },
  {
    title: "Business Admin Portal",
    copy: "Manage borrowers, loans, and repayments sa isang dashboard.",
    bullets: ["Real-time monitoring", "Mas madaling loan management"],
  },
  {
    title: "Secure Loan Processing",
    copy: "Protected ang user application and information.",
    bullets: ["Secure verification", "Digital KYC"],
  },
  {
    title: "Loan Reports and Insights",
    copy: "Access real-time reports and analytics.",
    bullets: ["Real-time notification", "Multiple payment channels"],
  },
  {
    title: "Scalable Lending Platform",
    copy: "Helping you serve more borrowers.",
    bullets: ["Faster loan approval", "Mobile first Experience"],
  },
];

export default function Partners() {
  useScrollReveal();

  return (
    <main className="partners-page">
      <SiteHeader />

      <section className="partners-hero tl-reveal">
        <div className="partners-hero-copy">
          <span>Grow together</span>
          <h1>
            Partner With <strong>trilLOAN</strong>
          </h1>
          <p>Maging Digital Lender na.</p>
          <a href="/partners/apply">
            Partner with us
            <ArrowForwardRoundedIcon />
          </a>
        </div>
        <img src={partnerHero} alt="Business partners discussing lending growth" />
      </section>

      <section className="partner-benefits-section tl-reveal">
        <div className="partner-section-heading">
          <h2>Why Partner With trilLOAN?</h2>
          <p>Palaguin ang inyong lending business sa tulong ng trilLOAN.</p>
        </div>
        <div className="partner-benefit-grid">
          {partnerBenefits.map((benefit, index) => (
            <article className={`tl-reveal tl-reveal-delay-${index % 3}`} key={benefit.title}>
              <span className="partner-card-icon">
                <CreditCardOutlinedIcon />
              </span>
              <h3>{benefit.title}</h3>
              <p>{benefit.copy}</p>
              <ul>
                {benefit.bullets.map((bullet) => (
                  <li key={bullet}>
                    <CheckCircleOutlineRoundedIcon />
                    {bullet}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <SecureConnected />
      <SiteFooter />
    </main>
  );
}
